import axios from "axios";
import * as constants from "../assets/constants";


class StorageApi {
    base_url = ""
    storage_id = "-1"

    constructor(base_url) {
        this.base_url = base_url
    }

    setItem = (key, value, onSaved = null) => {

        const body = new FormData()

        let sAjaxSource = '/?app=storage&act=setItem&storage_id=' + this.getStorageId()

        body.append('value', value);
        body.append('key', key);

        axios.post(this.base_url + sAjaxSource, body,
            {
                withCredentials: true


            }
        ).then((response) => {
            if (typeof onSaved === 'function') {
                onSaved()

            }
            window.postMessage('storageUpdate')
        })

    }

    getItem = async (key) => {

        const body = new FormData()

        let sAjaxSource = '/?app=storage&act=getItem&storage_id=' + this.getStorageId()

        body.append('key', key);

        const res = await axios.post(this.base_url + sAjaxSource, body,
            {
                withCredentials: true


            }
        )
        return await res.data
    }

    setStorageId = (id) => {
        this.storage_id = id
    }
    getStorageId = () => {

        return this.storage_id
    }
}

export default new StorageApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod)
export const GlobalStorageApi = new StorageApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod)